module.exports = __webpack_public_path__ + "static/Ecosystem-icon-12-348784af8286b07a010f63a331956b54.png";